exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".StoriesStream__separator--4I88W{border-color:#dcdcdc}.StoriesStream__spinnerWrapper--2mgmn{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}@media (max-width:1024px){.StoriesStream__spinnerWrapper--2mgmn{height:calc(100vh - 45px);position:fixed;top:45px;left:0;width:100%}}.StoriesStream__infinite--3rpZE{overflow:visible!important}", ""]);

// exports
exports.locals = {
	"separator": "StoriesStream__separator--4I88W",
	"spinnerWrapper": "StoriesStream__spinnerWrapper--2mgmn",
	"infinite": "StoriesStream__infinite--3rpZE"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"sourceMap":false}!./src/components/Library/StoriesStream/StoriesStream.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"sourceMap":false}!./src/components/Library/StoriesStream/StoriesStream.css
// module chunks = 1